import React, { useEffect, useState } from "react";
import "./MoreFilters.scss";
import { DateType, MoreFilterMapping } from "../../../features/searchpage/constants/filters.constants";
import { areParamsEqual, checkArrayInArray } from "../../../utils/globalUtilities";
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { SEARCH_API_CONSTANTS } from "../../../constants/search.constanst";
import { postData } from "../../../services/global.service";
import { APIEnv, APIStatus } from "../../../interface/baseInterfaces";
import Loader from "../../loader/Loader";
import Autosuggest from "../../autosuggest/autosuggest";
import DateRangeDropdown from "../../date-range-dropdown/date-range-dropdown";
import { CustomDialog } from "../../UI/dialog/custom-dialog";

interface FilterItem {
  id: string;
  name: string;
  ordering: number;
}

type FilterListsType = {
  [key: string]: FilterItem[];
};

interface FilterListProps {
  filterLists?: FilterListsType;
  onFilterFormDataChange?: Function,
  exsistingfilters: any
}

const MoreFilters: React.FC<FilterListProps> = ({ tab, onMoreFilterFormDataChange, exsistingMorefilters,onClose }: any) => {
  const [moreFilterFormData, setMoreFilterFormData] = useState<any>({});
  const [moreFilters, setMoreFilters] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [showDialog, setShowDialog] = useState<boolean>(false);

  const searchBody = {
    searchData: "",
    page: 1,
    pageSize: 20,
    filter: {},
    tabfilter: tab
      ? { id: tab.id, name: tab.name }
      : {},
    sortby: "relevance",
    sortorder: 1,
    isUroIncluded: true,
  };

  const isShowFilter = (tabsList: any) => {
    if (tab?.id) {
      return checkArrayInArray(tabsList, tab.id);
    } else {
      return checkArrayInArray(tabsList, 'search');
    }
  }
  useEffect(() => {
    if (tab?.id) {
      if (checkArrayInArray(MoreFilterMapping['JournalList']['tabMapping'], tab.id)) {
        getMoreFilters()
      }
    } else {
      if (checkArrayInArray(MoreFilterMapping['JournalList']['tabMapping'], 'search')) {
        getMoreFilters()
      }
    }
  }, [tab]);

  useEffect(() => {
    if (exsistingMorefilters) {
      if (!areParamsEqual(exsistingMorefilters, moreFilterFormData)) {
        setMoreFilterFormData(exsistingMorefilters)
      }
    }
  }, [exsistingMorefilters]);

  useEffect(() => {
    if (!loading) {
      setShowDialog(true);
    }
  }, [loading]);

  function getMoreFilters() {
    setLoading(true);
    postData(SEARCH_API_CONSTANTS.MORE_FILTERS,
      searchBody,
      APIEnv.NODE_PREMIUM).then((response => {
        setLoading(false);
        if (response?.ResponseType == APIStatus.SUCCESS) {
          setMoreFilters(response.data.filter);
        }
        setLoading(false);
      }
      )
      ).catch(err => {
        setLoading(false);
      })
  }
  useEffect(() => {
    let isMounted = true;
  
    const fetchFilters = async () => {
      const currentTabId = tab?.id || 'search';
      const shouldFetch = Object.values(MoreFilterMapping).some((mapping:any) =>
        checkArrayInArray(mapping.tabMapping, currentTabId)
      );
  
      if (shouldFetch) {
        getMoreFilters();
      } else {
        if (isMounted) setLoading(false);
      }
    };
  
    fetchFilters();
  
    return () => {
      isMounted = false;
    };
  }, [tab]);

  const onsubmit = () => {
    onMoreFilterFormDataChange(moreFilterFormData);
  }

  const onreset = () => {
    let selectionFilter = { ...exsistingMorefilters };
    let keys = Object.keys(selectionFilter);
    keys.forEach((key: string) => {
      selectionFilter[key] = [];
    });
    setMoreFilterFormData(selectionFilter);
    onMoreFilterFormDataChange(selectionFilter);
  }

  const onSetDateRangeDropdown = (data: any) => {
    setMoreFilterFormData({
      ...moreFilterFormData,
      ...data
    });
  }
  const handleDialogHide = () => {
    setShowDialog(false);
    onClose();
  };
  return (
    <>
     {loading && <Loader />}
      {!loading && (
        <CustomDialog
          dialogSize={"md-dialog"}
          dismissableMask={true}
          header={'More Filters'}
          component={<div className="group-form">
       {MoreFilterMapping &&
            Object.keys(MoreFilterMapping)
              .filter(
                (key) =>
                  MoreFilterMapping[key]['dataType'] === DateType.AUTOCOMPLETE &&
                  isShowFilter(MoreFilterMapping[key]['tabMapping'])
              )
              .map((key) => (
                <div className="group-form-row" key={`MoreFilter${key}`}>
                  <div className="group-form-colls">
                    <label className="form-label-1">
                      {MoreFilterMapping[key]['label']} 
                      {/* <span className="color-red">*</span> */}
                    </label>
                    <Autosuggest
                      value={moreFilterFormData[MoreFilterMapping[key]['apiKey']]}
                      type={MoreFilterMapping[key]['searchKey']}
                      onGetAutoSuggestValue={(value:any) =>
                        setMoreFilterFormData({
                          ...moreFilterFormData,
                          [MoreFilterMapping[key]['apiKey']]: value,
                        })
                      }
                    />
                  </div>
                </div>
              ))}
       

          {/* Group 3: Date-Related Fields */}
        
          <div key={`MoreFilterSelection`} className="group-form-row" >
            <div className="group-form-colls">
            <div className="group-flex-row">                       
          {MoreFilterMapping &&
            Object.keys(MoreFilterMapping)
              .filter(
                (key) =>
                  (MoreFilterMapping[key]['dataType'] === DateType.DATE ||
                    MoreFilterMapping[key]['dataType'] === DateType.DATE_DROPDOWN) &&
                  isShowFilter(MoreFilterMapping[key]['tabMapping'])
              )
              .map((key) => (
                
                  <div className="group-flex-colls pr-2" key={`MoreFilterDate${key}`}>
                    <label className="form-label-1">
                      {MoreFilterMapping[key]['label']} 
                      {/* <span className="color-red">*</span> */}
                      &nbsp;
                    </label>
                    {MoreFilterMapping[key]['dataType'] === DateType.DATE ? (
                     
                    <Calendar
                      key={key}
                      value={moreFilterFormData[MoreFilterMapping[key]['apiKey']]}
                      dateFormat="dd/mm/yy"
                      placeholder={MoreFilterMapping[key]['placeHolder']}
                      onChange={(e) =>
                        setMoreFilterFormData({
                          ...moreFilterFormData,
                          [MoreFilterMapping[key]['apiKey']]: e.value,
                          ...(key === 'fromDate' ? { toDate: null } : {}),
                        })
                      }
                      showIcon
                      {...(key === 'toDate' && {
                        disabled: !moreFilterFormData['fromDate'],
                        minDate: moreFilterFormData['fromDate'] || undefined,
                      })}
                    />
                     
                    ) : (
                      <DateRangeDropdown
                        fieldKey={key}
                        selectedFilters={moreFilterFormData}
                        onSetDateRangeDropdown={onSetDateRangeDropdown}
                      />
                    )}
                    </div>
                
               
              ))}
        </div>
        </div>
        </div>
       
        {/* Group 2: Basic Input Fields */}
       
         
          {MoreFilterMapping &&
            Object.keys(MoreFilterMapping)
              .filter(
                (key) =>
                  (MoreFilterMapping[key]['dataType'] === DateType.TEXT ||
                    MoreFilterMapping[key]['dataType'] === DateType.SELECT) &&
                  isShowFilter(MoreFilterMapping[key]['tabMapping'])
              )
              .map((key) => (
                <div className="group-form-row" key={`MoreFilterSelection${key}`}>
                  <div className="group-form-colls">
                    <label className="form-label-1">
                      {MoreFilterMapping[key]['label']} 
                      {/* <span className="color-red">*</span> */}
                    </label>
                    {MoreFilterMapping[key]['dataType'] === DateType.TEXT ? (
                      <input
                        value={moreFilterFormData[MoreFilterMapping[key]['apiKey']]}
                        type="number"
                        onChange={(e) =>
                          setMoreFilterFormData({
                            ...moreFilterFormData,
                            [MoreFilterMapping[key]['apiKey']]: e.target.value,
                          })
                        }
                        className="form-control-t1"
                      />
                    ) : (
                      <MultiSelect
                        className="p-multiselect-Mod1"
                        value={moreFilterFormData[MoreFilterMapping[key]['apiKey']]}
                        options={moreFilters[key]}
                        optionLabel={MoreFilterMapping[key]['valueLabel']}
                        onChange={(e) =>
                          setMoreFilterFormData({
                            ...moreFilterFormData,
                            [MoreFilterMapping[key]['apiKey']]: e.value,
                          })
                        }
                        maxSelectedLabels={6}
                      />
                    )}
                  </div>
                </div>
              ))}
       
  
      
  
        {/* Submit and Reset Buttons */}
        <div className="group-form-row">
          <div className="group-form-colls">
            <a
              className="button-primary active cursor-pointer"
              onClick={() => onsubmit()}
            >
              Submit
            </a>
            <a
              className="button-primary cursor-pointer"
              onClick={() => onreset()}
            >
              Reset
            </a>
          </div>
        </div>
      </div>
    }
    onDialogHide={handleDialogHide}
        visible={showDialog}
      />)}
  </>
  
  );
};

export default MoreFilters;
